export default __webpack_public_path__ + "static/media/loginInFrequently.22bc902e.svg";